import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import { CSS } from "src/_utils/styles";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";
import { ProductFeatures, ProductGrid, SkeletonLoader } from "../Products/ProductsCommon";
import { EBSSSPagination } from "src/base/atoms/EBSSSPagination";
import { useSelector } from "react-redux";
import { ReduxDataKey } from "src/base/store/store";
import { getQueryParams } from "src/_utils/urls";
import { scrollUpPage } from "src/_utils/elements";
import { Session } from "src/base/store/authSlice";
import EBSSSModal from "src/base/atoms/EBSSSModal";
import { Image } from "src/AbstractElements";
import EBSSSTooltip from "src/base/atoms/EBSSSTooltip";

const SellerSearchPage = () => {
  const { trans } = useEBSSSLayout();
  const getSeller = useParams();
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const { products, categories, seller, loaded, appSettings, fetchSellerSearch } = useEBSSS();
  const [page, setPage] = useState(null);
  const [ordering, setOrdering] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [filterSize, setFilterSize] = useState(undefined);
  const [stepSize, setStepSize] = useState(0);
  const [values, setValues] = useState([1, 100]);
  const [modal, setModal] = useState(false);
  const [filterPrice, setFilterPrice] = useState({
    min: 0,
    max: undefined,
  });

  const toggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    if (!!products && Array.isArray(products?.data) && products?.data?.length) {
      let filtersPriceMinMax = {
        ...filterPrice,
        max: Math.ceil(Number(products?.data?.sort((a, b) => Number(b.price) - Number(a.price))[0]?.price)),
      };
      setFilterPrice({
        ...filtersPriceMinMax,
      });
      setStepSize(
        //@ts-ignore
        String(products?.data?.sort((a, b) => Number(b.price) - Number(a.price))[0]?.price ?? 0) / 20
      );
      setValues([filtersPriceMinMax.min, filtersPriceMinMax.max]);
    }
  }, [products?.data]);

  useEffect(() => {
    let actualParams = getQueryParams(window.location.href);
    if (actualParams?.page) {
      setPage((p) => {
        if (p !== null) {
          return p;
        } else {
          return Number(actualParams?.page);
        }
      });
    }
  }, [window.location.search]);

  useEffect(() => {
    scrollUpPage();
    if (products?.data) {
      if (page && page > 0) {
        fetchSellerSearch(getSeller?.slug, page, getSeller?.name, getSeller?.token ?? null);
      }
    }
  }, [page]);

  useEffect(() => {
    scrollUpPage();
    fetchSellerSearch(getSeller?.slug, { page: 1 }, getSeller?.name, getSeller?.token ?? null);
  }, []);

  return (
    <Page breads={[]} hideTitle hideBreadcrumbs>
      <div className="d-flex flex-column pt-4">
        <div className="w-100 p-4 mb-3" style={CSS({ height: 200, backgroundColor: "#00000000" })}>
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-column gap-3">
              {appSettings?.images && appSettings?.images?.length > 0 ? (
                <Image
                  attrImage={{
                    className: "img-fluid",
                    src: appSettings?.images[0],
                    width: 100,
                    height: "auto",
                  }}
                />
              ) : (
                <></>
              )}
              <div className="d-flex flex-row gap-2 align-items-baseline">
                <h3>{appSettings?.seller_fullname}</h3>
                {appSettings?.verified === "enabled" ? <EBSSSTooltip icon="la la-check" title={trans("website.verified")} /> : <></>}
              </div>
              {appSettings?.opened ? (
                <span className="badge bg-success">{trans("common.store-open")}</span>
              ) : appSettings?.opened === null ? (
                <span className="badge bg-danger">{trans("common.store-unavailable-work-hour")}</span>
              ) : (
                <span className="badge bg-warning">{trans("common.store-closed")}</span>
              )}
            </div>
            <div className="d-flex flex-column">
              {appSettings?.address ? (
                <div className="d-flex flex-column">
                  <span>
                    {appSettings?.address?.address_line_1} {appSettings?.address?.address_line_2}
                  </span>
                  <span>{appSettings?.address?.postal_code}</span>
                  <span>{appSettings?.address?.locality}</span>
                  <span>{appSettings?.address?.location}</span>
                </div>
              ) : seller?.seller?.addresses && seller?.seller?.addresses?.length > 1 ? (
                <EBSSSModal
                  hideFooter
                  modalTitle={trans("website.addresses")}
                  toggle={toggle}
                  modal={modal}
                  triggerEl={
                    <div onClick={toggle} style={CSS({ cursor: "pointer" })} className="d-flex flex-row gap-3 align-items-center badge bg-primary">
                      <i className="la la-home fs-4"></i>
                      <span className="fs-6">{trans("website.addresses")}</span>
                    </div>
                  }
                >
                  {seller?.seller?.addresses && seller?.seller?.addresses?.length > 1 ? (
                    <div>
                      <h4 className="mb-4">{trans("website.our-addresses")}</h4>
                      {seller?.seller?.addresses?.map((addr, addrIdx) => (
                        <div key={addr.id} className="d-flex flex-row gap-3">
                          <i className="la la-home fs-5"></i>
                          <div className="d-flex flex-column gap-1">
                            <span>
                              {addr.address_line_1} {addr.address_line_2}
                            </span>
                            <span>{addr.postal_code}</span>
                            <span>{addr.locality}</span>
                            <span>{addr.location}</span>
                            {addrIdx !== seller?.seller?.addresses?.length - 1 ? <hr /> : <></>}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </EBSSSModal>
              ) : seller?.seller?.addresses && seller?.seller?.addresses?.length === 1 ? (
                <div className="d-flex flex-column">
                  <span>
                    {seller?.seller?.addresses[0]?.address_line_1} {seller?.seller?.addresses[0]?.address_line_2}
                  </span>
                  <span>{seller?.seller?.addresses[0]?.postal_code}</span>
                  <span>{seller?.seller?.addresses[0]?.locality}</span>
                  <span>{seller?.seller?.addresses[0]?.location}</span>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        <Fragment>
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid mb-3">
              <ProductFeatures
                values={values}
                setValues={setValues}
                categories={categories}
                sortBy={sortBy}
                setSortBy={setSortBy}
                filterSize={filterSize}
                setFilterSize={setFilterSize}
                stepSize={stepSize}
                setStepSize={setStepSize}
                filterPrice={filterPrice}
                setFilterPrice={setFilterPrice}
                basePath={"/crm/seller/" + getSeller?.slug}
                categoryPath={"/crm/seller/" + getSeller?.slug + "/category"}
                searchPath={"/crm/seller/" + getSeller?.slug + "/search"}
              />
              {!loaded ? (
                <div className="d-flex flex-row flex-wrap">
                  <SkeletonLoader isLoading={!loaded} />
                </div>
              ) : (
                <ProductGrid perLine={Number(appSettings?.columns)} products={products} trans={trans} values={values} sortBy={sortBy} filterSize={filterSize} />
              )}
              <EBSSSPagination page={page} data={products} />
            </div>
          </Container>
        </Fragment>
      </div>
    </Page>
  );
};

export default SellerSearchPage;
